import * as React from "react";
import Box from "@mui/material/Box";
import Tab, { tabClasses } from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Divider,
  IconButton,
  Tooltip,
  buttonClasses,
  styled,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import ListWidget from "../widgets/ListWidget";
import ListQuery from "../query-tool/ListQuery";
import QueryTool from "../query-tool/queryTool";
import CreateWidget2 from "../widgets/CreateWidget2";
import EditWidget2 from "../widgets/EditWidget";
import EditQuery from "../query-tool/EditQuery";
import EditWidget from "../widgets/EditWidget";
import ListDatasource from "../data-source/ListDatasource";
import CreateDataSource from "../data-source/CreateDataSource";
import EditDataSource from "../data-source/EditDataSource";
import "./listCommon.css";
import MappingScreen from "../mapping/MappingScreen";
import ListRole from "../roles/ListRole";
import CreateRole from "../roles/CreateRole";
import EditRole from "../roles/EditRole";
import ListGroups from "../groups/ListGroups";
import CreateGroup from "../groups/CreateGroup";
import EditGroup from "../groups/EditGroup";
import Tooltips from "../../../components/bootstrap/Tooltips";
import VyuGPT from "../vyu-gpt/VyuGPT";
import ReportGrid from "../report-grid/ReportGrid";
const CustomTab = styled(Tab)`
   font-family: SF Pro Display;
    color: #000000;
    cursor: pointer;
    width: 9%;
    min-height: 0px;
    height: 34px;
    font-size: 0.8rem;
    text-transform: 'capitalize';
    // background-color: #D5D5D5;
    background-color: #f8f8f8;
    align-self: flex-end;
    margin-left: 0.35%;
    // margin-right: 0.35%;
    // border: 2px solid #D5D5D5 ;
    // border-top-left-radius: 8px;
    // border-top-right-radius: 8px;

    &.${tabClasses.selected} {
     // background: #5281CE;
      background: #e8e8e8;
      // color: #000000;
      // border: none;
      // border-top-left-radius: 8px;
      // border-top-right-radius: 8px;
      --r: 0em; /* control the curvature */
      border: solid #696969;
      border-width: 0 var(--r);
      // border-radius: calc(2 * var(--r)) calc(2 * var(--r)) 0 0 / var(--r);
      border-radius: 8px;
      mask:
        radial-gradient(var(--r) at var(--r) 0, #0000 98%, #000 100%)
          calc(-1 * var(--r)) 100%/100% var(--r) repeat-x,
        conic-gradient(#000 0 0) padding-box;

    }
    }

    &.${buttonClasses.disabled} {
        cursor: not-allowed;
    }
  `;

const CustomTabsList = styled(TabList)(
  ({ theme }) => `
    width: 100%;
    margin-left: 15px;
    // display: flex;
    // flex-direction: row;
    `
);

export default function ListCommonComponent(props: any) {
  const [isLoading, setLoading] = useState(true);
  const [component, setComponent] = useState("");
  const [selectedTab, setSelectedTab] = useState("1");
  const [previousTab, setPreviousTab] = useState(selectedTab);
  const [mappingTab, setMappingTab] = useState("list");
  const [listOfCustomTabsJSX, setListOfCustomTabsJSX] = useState<
    React.ReactElement[]
  >([customTabJsx("1", "List"), customTabJsx("2", "Create")]);
  const [listOfCustomTabPanelsJSX, setListOfCustomTabPanelsJSX] = useState<
    React.ReactElement[]
  >([
    tabPanelJSX(ListWidget, { name: "somename", addEditTabPanelAndEntry }, "1"),
    tabPanelJSX(CreateWidget2, {}, "2"),
  ]);
  const companyInfo: any = localStorage.getItem("companyInfo");
  const parsedCompanyInfo = JSON.parse(companyInfo);
  useEffect(() => {
    if (props.component !== component) {
      setComponent(props.component);
    }
  }, [props.component]);
  //Widget Tab variables and function -- start
  const [widgetList, setWidgetList] = useState<{
    type: "add" | "delete";
    detail: WidgetDetail[];
    newId: number;
  }>({ type: "delete", detail: [], newId: 0 });
  const [selectedWidgetTab, setSelectedWidgetTab] = useState("list");

  useEffect(() => {
    if (widgetList.type === "add") {
      handleWidgetTabChange(null, widgetList.newId.toString());
    } else if (widgetList.type === "delete") {
      if (widgetList.newId === -1) {
        handleWidgetTabChange(null, "list");
      } else {
        handleWidgetTabChange(null, widgetList.newId.toString());
      }
    }
  }, [widgetList]);
  interface WidgetDetail {
    id: number;
    name: string;
  }

  function deleteWidgetTab(id: number) {
    setWidgetList({
      type: "delete",
      detail: widgetList.detail.filter((widget) => widget.id !== id),
      newId:
        id.toString() === selectedWidgetTab ? -1 : Number(selectedWidgetTab),
    });
  }

  const handleWidgetTabChange = (event: any, newValue: any) => {
    if (newValue === "create" || newValue === "list") {
      setSelectedWidgetTab(newValue);
    }
    const isPresent = widgetList.detail.some(
      (item: WidgetDetail) => item.id.toString() === newValue
    );
    if (isPresent) {
      setSelectedWidgetTab(newValue);
    }
  };
  //Widget Tab variables and function -- end

  //Query Tab variables and function -- start
  const [queryList, setQueryList] = useState<{
    type: "add" | "delete";
    detail: QueryDetail[];
    newId: number;
  }>({ type: "delete", detail: [], newId: 0 });
  const [selectedQueryTab, setSelectedQueryTab] = useState("list");

  useEffect(() => {
    if (queryList.type === "add") {
      handleQueryTabChange(null, queryList.newId.toString());
    } else if (queryList.type === "delete") {
      if (queryList.newId === -1) {
        handleQueryTabChange(null, "list");
      } else {
        handleQueryTabChange(null, queryList.newId.toString());
      }
    }
  }, [queryList]);
  interface QueryDetail {
    id: number;
    name: string;
  }

  function deleteQueryTab(id: number) {
    setQueryList({
      type: "delete",
      detail: queryList.detail.filter((query) => query.id !== id),
      newId: id.toString() === selectedQueryTab ? -1 : Number(selectedQueryTab),
    });
  }

  const handleQueryTabChange = (event: any, newValue: any) => {
    if (newValue === "create" || newValue === "list") {
      setSelectedQueryTab(newValue);
    }
    const isPresent = queryList.detail.some(
      (item: QueryDetail) => item.id.toString() === newValue
    );
    if (isPresent) {
      setSelectedQueryTab(newValue);
    }
  };
  //Query Tab variables and function -- end

  // DataSource tab variables and functions -- start
  const [dataSourceList, setDataSourceList] = useState<{
    type: "add" | "delete";
    detail: DataSourceDetail[];
    newId: number;
  }>({ type: "delete", detail: [], newId: 0 });
  const [selectedDataSourceTab, setSelectedDataSourceTab] = useState("list");

  useEffect(() => {
    if (dataSourceList.type === "add") {
      handleDataSourceTabChange(null, dataSourceList.newId.toString());
    } else if (queryList.type === "delete") {
      if (dataSourceList.newId === -1) {
        handleDataSourceTabChange(null, "list");
      } else {
        handleDataSourceTabChange(null, dataSourceList.newId.toString());
      }
    }
  }, [dataSourceList]);
  interface DataSourceDetail {
    id: number;
    name: string;
  }

  function deleteDataSourceTab(id: number) {
    setDataSourceList({
      type: "delete",
      detail: dataSourceList.detail.filter((ds) => ds.id !== id),
      newId:
        id.toString() === selectedDataSourceTab
          ? -1
          : Number(selectedDataSourceTab),
    });
  }

  const handleDataSourceTabChange = (event: any, newValue: any) => {
    if (newValue === "create" || newValue === "list") {
      setSelectedDataSourceTab(newValue);
    }
    const isPresent = dataSourceList.detail.some(
      (item: DataSourceDetail) => item.id.toString() === newValue
    );
    if (isPresent) {
      setSelectedDataSourceTab(newValue);
    }
  };

  const handleMappingTabChange = (event: any, newValue: any) => {
    setMappingTab(newValue);
  };
  // DataSource tab variables and functions -- start

  const [roleList, setRoleList] = useState<{
    type: "add" | "delete";
    detail: RoleDetail[];
    newId: number;
  }>({ type: "delete", detail: [], newId: 0 });
  const [selectedRoleTab, setSelectedRoleTab] = useState("list");

  useEffect(() => {
    if (roleList.type === "add") {
      handleRoleTabChange(null, roleList.newId.toString());
    } else if (roleList.type === "delete") {
      if (roleList.newId === -1) {
        handleRoleTabChange(null, "list");
      } else {
        handleRoleTabChange(null, roleList.newId.toString());
      }
    }
  }, [roleList]);
  interface RoleDetail {
    id: number;
    name: string;
  }

  function deleteRoleTab(id: number) {
    setRoleList({
      type: "delete",
      detail: roleList.detail.filter((ds) => ds.id !== id),
      newId: id.toString() === selectedRoleTab ? -1 : Number(selectedRoleTab),
    });
  }

  const handleRoleTabChange = (event: any, newValue: any) => {
    if (newValue === "create" || newValue === "list") {
      setSelectedRoleTab(newValue);
    }
    const isPresent = roleList.detail.some(
      (item: RoleDetail) => item.id.toString() === newValue
    );
    if (isPresent) {
      setSelectedRoleTab(newValue);
    }
  };
  // Roles tab variables and functions -- end

  // Groups tab variables and functions -- start
  const [groupsList, setGroupsList] = useState<{
    type: "add" | "delete";
    detail: GroupDetail[];
    newId: number;
  }>({ type: "delete", detail: [], newId: 0 });
  const [selectedGroupTab, setSelectedGroupTab] = useState("list");
  interface GroupDetail {
    id: number;
    name: string;
  }
  useEffect(() => {
    if (groupsList.type === "add") {
      handleGroupTabChange(null, groupsList.newId.toString());
    } else if (groupsList.type === "delete") {
      if (groupsList.newId === -1) {
        handleGroupTabChange(null, "list");
      } else {
        handleGroupTabChange(null, groupsList.newId.toString());
      }
    }
  }, [groupsList]);
  function deleteGroupTab(id: number) {
    setGroupsList({
      type: "delete",
      detail: groupsList.detail.filter((ds) => ds.id !== id),
      newId: id.toString() === selectedGroupTab ? -1 : Number(selectedGroupTab),
    });
  }

  const handleGroupTabChange = (event: any, newValue: any) => {
    // console.log(event, newValue);
    if (newValue === "create" || newValue === "list") {
      setSelectedGroupTab(newValue);
    }
    const isPresent = groupsList.detail.some(
      (item: GroupDetail) => item.id.toString() === newValue
    );
    // console.log(isPresent);
    if (isPresent) {
      // console.log(newValue);
      setSelectedGroupTab(newValue);
    }
  };

  const handletabChange = (event: any, newValue: any, currentTab: any) => {
    setPreviousTab(currentTab);
    setSelectedTab(newValue);
  };
  function deleteTab(event: React.MouseEvent<HTMLElement>, value: any) {
    event.stopPropagation();
    // console.log(value);
    // console.log(listOfCustomTabPanelsJSX, listOfCustomTabsJSX);
    setListOfCustomTabsJSX((prev) =>
      prev.filter((item) => item.props.value !== value)
    );
    setListOfCustomTabPanelsJSX((prev) =>
      prev.filter((item) => item.props.value !== value)
    );
    // console.log(selectedTab);
    // console.log("prevtab", previousTab);
    setSelectedTab("1");
    // handletabChange(null, previousTab, selectedTab);
  }
  function customTabJsx(value: any, label: string): React.ReactElement {
    let hide = value > 2 ? true : false;
    return (
      <CustomTab
        LinkComponent={EditWidget2}
        value={value}
        label={
          <Tooltip title={label}>
            <div style={{ display: "flex" }}>
              {label.substring(0, 6)}
              {hide && (
                <IconButton
                  sx={{
                    marginBottom: -1,
                  }}
                  hidden={true}
                  size="small"
                  onClick={(event: React.MouseEvent<HTMLElement>) =>
                    deleteTab(event, value)
                  }
                >
                  <CloseIcon sx={{ marginTop: -1, fontSize: 17 }} />
                </IconButton>
              )}
            </div>
          </Tooltip>
        }
      ></CustomTab>
    );
  }
  function tabPanelJSX(
    ComponentTag: any,
    props = {},
    value: string
  ): React.ReactElement {
    return (
      <>
        <TabPanel value={value}>
          <ComponentTag {...props} />
        </TabPanel>
      </>
    );
  }
  function addEditTabPanelAndEntry(props: any | undefined): any {
    // console.log(props.data.id);
    // console.log(listOfCustomTabsJSX.length, listOfCustomTabPanelsJSX.length);
    let tabIndex = String(listOfCustomTabsJSX.length + 1);
    let tempProps: any = "tempProps";
    setListOfCustomTabsJSX((prev) => {
      tabIndex = String(prev.length + 1);
      tempProps = props;
      return [...prev, customTabJsx(tabIndex, `${tempProps?.data?.name}`)];
    });
    // console.log("before setting props data id ", tempProps.data.id);
    setListOfCustomTabPanelsJSX((prev) => {
      tabIndex = String(prev.length + 1);
      sessionStorage.setItem("editTabId", String(tempProps.data.id));
      return [
        ...prev,
        tabPanelJSX(
          EditWidget2,
          { id: tempProps.data.id, name: tempProps.data.name },
          tabIndex
        ),
      ];
    });
    // console.log(listOfCustomTabsJSX);
    setSelectedTab(tabIndex);
    // handletabChange(null,tabIndex,selectedTab);
  }

  const TabDivider = () => (
    <Box
      sx={{
        width: "25px",
        borderTop: "1px solid #B2B2B2",
        transform: "rotate(90deg)",
        alignSelf: "center",
      }}
    />
  );

  if (!isLoading) {
    return (
      <Box sx={{ alignContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  } else if (component === "widget")
    return (
      <TabContext value={selectedWidgetTab}>
        <Box className="tab-list-box-common">
          <div className="company-info">
            <img
              src={parsedCompanyInfo.companyLogo}
              alt="Proeffective Logo"
              className="company-logo"
            />
            {parsedCompanyInfo.show === true && (
              <span className="vyu-text">{parsedCompanyInfo.companyName}</span>
            )}
          </div>
          <CustomTabsList
            onChange={(event, val) => handleWidgetTabChange(event, val)}
            sx={{
              background: "#f8f8f8",
              border: "1px solid #eaecf0",
              borderRadius: "8px",
            }}
          >
            <CustomTab
              value={"list"}
              label={
                <Tooltips title={"List Widget"} placement="right">
                  <span className="tab-header">List Widget</span>
                </Tooltips>
              }
            />
            <Box
              sx={{
                width: "25px",
                borderTop: "1px solid #B2B2B2",
                transform: "rotate(90deg)",
                alignSelf: "center",
                display:
                  selectedWidgetTab === "list" || selectedWidgetTab === "create"
                    ? "none"
                    : "block",
              }}
            />
            <CustomTab
              value={"create"}
              label={
                <Tooltips title={"Create Widget"} placement="right">
                  <span className="tab-header">Create Widget</span>
                </Tooltips>
              }
            />

            {widgetList.detail.length > 0 && (
              <Box
                sx={{
                  width: "25px",
                  borderTop: "1px solid #B2B2B2",
                  transform: "rotate(90deg)",
                  alignSelf: "center",
                  display:
                    selectedWidgetTab === "create" ||
                    selectedWidgetTab === widgetList.detail[0].id.toString()
                      ? "none"
                      : "block",
                }}
              />
            )}
            {widgetList.detail.map((widget) => (
              <CustomTab
                value={widget.id.toString()}
                label={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span style={{ flexGrow: 1 }}>
                      {widget.name.length > 4
                        ? `${widget.name.slice(0, 4)}...`
                        : widget.name}
                    </span>
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        deleteWidgetTab(widget.id);
                      }}
                    >
                      <CloseIcon
                        sx={{
                          color: "#000000",
                          fontWeight: 600,
                        }}
                      ></CloseIcon>
                    </IconButton>
                  </div>
                }
              />
            ))}
          </CustomTabsList>
        </Box>
        <div className="mapping-tab-line" />
        <TabPanel value="list">
          <ListWidget widgetList={widgetList} setWidgetList={setWidgetList} />
        </TabPanel>
        <TabPanel value="create">
          <CreateWidget2 />
        </TabPanel>
        {widgetList.detail.map((widget) => (
          <TabPanel value={widget.id.toString()}>
            <EditWidget widgetId={widget.id} />
          </TabPanel>
        ))}
      </TabContext>
    );
  else if (component === "queryTool")
    return (
      <TabContext value={selectedQueryTab}>
        <Box className="tab-list-box-common">
          <div className="company-info">
            <img
              src={parsedCompanyInfo.companyLogo}
              alt="Proeffective Logo"
              className="company-logo"
            />
            {parsedCompanyInfo.show === true && (
              <span className="vyu-text">{parsedCompanyInfo.companyName}</span>
            )}
          </div>
          <CustomTabsList
            onChange={(event, val) => handleQueryTabChange(event, val)}
            sx={{
              background: "#f8f8f8",
              border: "1px solid #eaecf0",
              borderRadius: "8px",
            }}
          >
            <CustomTab
              value={"list"}
              label={
                <Tooltips title={"List Query"} placement="right">
                  <span className="tab-header">List Query</span>
                </Tooltips>
              }
            />
            <Box
              sx={{
                width: "25px",
                borderTop: "1px solid #B2B2B2",
                transform: "rotate(90deg)",
                alignSelf: "center",
                display:
                  selectedQueryTab === "list" || selectedQueryTab === "create"
                    ? "none"
                    : "block",
              }}
            />
            <CustomTab
              value={"create"}
              label={
                <Tooltips title={"Create Query"} placement="right">
                  <span className="tab-header">Create Query</span>
                </Tooltips>
              }
            />
            {queryList.detail.length > 0 && (
              <Box
                sx={{
                  width: "25px",
                  borderTop: "1px solid #B2B2B2",
                  transform: "rotate(90deg)",
                  alignSelf: "center",
                  display:
                    selectedQueryTab === "create" ||
                    selectedQueryTab === queryList.detail[0].id.toString()
                      ? "none"
                      : "block",
                }}
              />
            )}
            {queryList.detail.map((query) => (
              <CustomTab
                value={query.id.toString()}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ flexGrow: 1 }}>
                      {query.name.length > 4
                        ? `${query.name.slice(0, 4)}...`
                        : query.name}
                    </span>
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        deleteQueryTab(query.id);
                      }}
                    >
                      <CloseIcon
                        sx={{
                          color: "#000000",
                          fontWeight: 600,
                          justifyContent: "flex-end",
                        }}
                      ></CloseIcon>
                    </IconButton>
                  </div>
                }
              />
            ))}
          </CustomTabsList>
        </Box>
        <div className="mapping-tab-line" />
        <TabPanel value="list">
          <ListQuery queryList={queryList} setQueryList={setQueryList} />
        </TabPanel>
        <TabPanel value="create">
          <QueryTool />
        </TabPanel>
        {queryList.detail.map((query) => (
          <TabPanel value={query.id.toString()}>
            <EditQuery queryId={query.id} />
          </TabPanel>
        ))}
      </TabContext>
    );
  else if (component === "DataSource")
    return (
      <TabContext value={selectedDataSourceTab}>
        <Box className="tab-list-box-common">
          <div className="company-info">
            <img
              src={parsedCompanyInfo.companyLogo}
              alt="Proeffective Logo"
              className="company-logo"
            />
            {parsedCompanyInfo.show === true && (
              <span className="vyu-text">{parsedCompanyInfo.companyName}</span>
            )}
          </div>
          <CustomTabsList
            onChange={(event, val) => handleDataSourceTabChange(event, val)}
            sx={{
              background: "#f8f8f8",
              border: "1px solid #eaecf0",
              borderRadius: "8px",
            }}
          >
            <CustomTab
              value={"list"}
              label={
                <Tooltips title={"List Datasource"} placement="right">
                  <span className="tab-header">List Datasource</span>
                </Tooltips>
              }
            />
            <Box
              sx={{
                width: "25px",
                borderTop: "1px solid #B2B2B2",
                transform: "rotate(90deg)",
                alignSelf: "center",
                display:
                  selectedDataSourceTab === "list" ||
                  selectedDataSourceTab === "create"
                    ? "none"
                    : "block",
              }}
            />
            <CustomTab
              value={"create"}
              label={
                <Tooltips title={"Create Datasource"} placement="right">
                  <span className="tab-header">Create Datasource</span>
                </Tooltips>
              }
            />
            {dataSourceList.detail.length > 0 && (
              <Box
                sx={{
                  width: "25px",
                  borderTop: "1px solid #B2B2B2",
                  transform: "rotate(90deg)",
                  alignSelf: "center",
                  display:
                    selectedDataSourceTab === "create" ||
                    selectedDataSourceTab ===
                      dataSourceList.detail[0].id.toString()
                      ? "none"
                      : "block",
                }}
              />
            )}
            {dataSourceList.detail.map((ds) => (
              <CustomTab
                value={ds.id.toString()}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ flexGrow: 1 }}>
                      {ds.name.length > 4
                        ? `${ds.name.slice(0, 4)}...`
                        : ds.name}
                    </span>
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        deleteDataSourceTab(ds.id);
                      }}
                    >
                      <CloseIcon
                        sx={{
                          color: "#000000",
                          fontWeight: 600,
                        }}
                      ></CloseIcon>
                    </IconButton>
                  </div>
                }
              />
            ))}
          </CustomTabsList>
        </Box>
        <div className="mapping-tab-line" />
        <TabPanel value="list">
          <ListDatasource
            dataSourceList={dataSourceList}
            setDataSourceList={setDataSourceList}
          />
        </TabPanel>
        <TabPanel value="create">
          <CreateDataSource />
        </TabPanel>
        {dataSourceList.detail.map((ds) => (
          <TabPanel value={ds.id.toString()}>
            <EditDataSource dataSourceId={ds.id} />
          </TabPanel>
        ))}
      </TabContext>
    );
  else if (component === "mapping")
    return (
      <TabContext value={mappingTab}>
        <Box className="tab-list-box-common">
          <div className="company-info">
            <img
              src={parsedCompanyInfo.companyLogo}
              alt="Proeffective Logo"
              className="company-logo"
            />
            {parsedCompanyInfo.show === true && (
              <span className="vyu-text">{parsedCompanyInfo.companyName}</span>
            )}
          </div>
          <CustomTabsList
            onChange={(event, val) => handleMappingTabChange(event, val)}
            sx={{
              background: "#f8f8f8",
              border: "1px solid #eaecf0",
              borderRadius: "8px",
            }}
          >
            <CustomTab
              value={"list"}
              label={
                <Tooltips title={"Mapping"} placement="right">
                  <span className="tab-header">Mapping</span>
                </Tooltips>
              }
            />
          </CustomTabsList>
        </Box>
        <div className="mapping-tab-line" />
        <TabPanel value="list">
          <MappingScreen />
        </TabPanel>
      </TabContext>
    );
  else if (component === "Roles")
    return (
      <TabContext value={selectedRoleTab}>
        <Box className="tab-list-box-common">
          <div className="company-info">
            <img
              src={parsedCompanyInfo.companyLogo}
              alt="Proeffective Logo"
              className="company-logo"
            />
            {parsedCompanyInfo.show === true && (
              <span className="vyu-text">{parsedCompanyInfo.companyName}</span>
            )}
          </div>
          <CustomTabsList
            onChange={(event, val) => handleRoleTabChange(event, val)}
            sx={{
              background: "#f8f8f8",
              border: "1px solid #eaecf0",
              borderRadius: "8px",
            }}
          >
            <CustomTab
              value={"list"}
              label={
                <Tooltips title={"List Roles"} placement="right">
                  <span className="tab-header">List Roles</span>
                </Tooltips>
              }
            />
            <Box
              sx={{
                width: "25px",
                borderTop: "1px solid #B2B2B2",
                transform: "rotate(90deg)",
                alignSelf: "center",
                display:
                  selectedRoleTab === "list" || selectedRoleTab === "create"
                    ? "none"
                    : "block",
              }}
            />
            <CustomTab
              value={"create"}
              label={
                <Tooltips title={"Create Roles"} placement="right">
                  <span className="tab-header">Create Roles</span>
                </Tooltips>
              }
            />
            {roleList.detail.length > 0 && (
              <Box
                sx={{
                  width: "25px",
                  borderTop: "1px solid #B2B2B2",
                  transform: "rotate(90deg)",
                  alignSelf: "center",
                  display:
                    selectedRoleTab === "create" ||
                    selectedRoleTab === roleList.detail[0].id.toString()
                      ? "none"
                      : "block",
                }}
              />
            )}
            {roleList.detail.map((rl) => (
              <CustomTab
                value={rl.id.toString()}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ flexGrow: 1 }}>
                      {rl.name.length > 4
                        ? `${rl.name.slice(0, 4)}...`
                        : rl.name}
                    </span>

                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        deleteRoleTab(rl.id);
                      }}
                    >
                      <CloseIcon
                        sx={{
                          color: "#000000",
                          fontWeight: 600,
                        }}
                      ></CloseIcon>
                    </IconButton>
                  </div>
                }
              />
            ))}
          </CustomTabsList>
        </Box>
        <div className="mapping-tab-line" />
        <TabPanel value="list">
          <ListRole roleList={roleList} setRoleList={setRoleList} />
        </TabPanel>
        <TabPanel value="create">
          <CreateRole />
        </TabPanel>
        {roleList.detail.length > 0 && (
          <Box
            sx={{
              width: "25px",
              borderTop: "1px solid #B2B2B2",
              transform: "rotate(90deg)",
              alignSelf: "center",
              display:
                selectedRoleTab === "create" ||
                selectedRoleTab === roleList.detail[0].id.toString()
                  ? "none"
                  : "block",
            }}
          />
        )}
        {roleList.detail.map((rl) => (
          <TabPanel value={rl.id.toString()}>
            <EditRole roleId={rl.id} />
          </TabPanel>
        ))}
      </TabContext>
    );
  else if (component === "Groups")
    return (
      <TabContext value={selectedGroupTab}>
        <Box className="tab-list-box-common">
          <div className="company-info">
            <img
              src={parsedCompanyInfo.companyLogo}
              alt="Proeffective Logo"
              className="company-logo"
            />
            {parsedCompanyInfo.show === true && (
              <span className="vyu-text">{parsedCompanyInfo.companyName}</span>
            )}
          </div>
          <CustomTabsList
            onChange={(event, val) => handleGroupTabChange(event, val)}
            sx={{
              background: "#f8f8f8",
              border: "1px solid #eaecf0",
              borderRadius: "8px",
            }}
          >
            <CustomTab
              value={"list"}
              label={
                <Tooltips title={"List Group"} placement="right">
                  <span className="tab-header">List Group</span>
                </Tooltips>
              }
            />
            <Box
              sx={{
                width: "25px",
                borderTop: "1px solid #B2B2B2",
                transform: "rotate(90deg)",
                alignSelf: "center",
                display:
                  selectedGroupTab === "list" || selectedGroupTab === "create"
                    ? "none"
                    : "block",
              }}
            />
            <CustomTab
              value={"create"}
              label={
                <Tooltips title={"Create Group"} placement="right">
                  <span className="tab-header">Create Group</span>
                </Tooltips>
              }
            />
            {groupsList.detail.length > 0 && (
              <Box
                sx={{
                  width: "25px",
                  borderTop: "1px solid #B2B2B2",
                  transform: "rotate(90deg)",
                  alignSelf: "center",
                  display:
                    selectedGroupTab === "create" ||
                    selectedGroupTab === groupsList.detail[0].id.toString()
                      ? "none"
                      : "block",
                }}
              />
            )}
            {groupsList.detail.map((ds) => (
              <CustomTab
                value={ds.id.toString()}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ flexGrow: 1 }}>
                      {ds.name.length > 4
                        ? `${ds.name.slice(0, 4)}...`
                        : ds.name}
                    </span>
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        deleteGroupTab(ds.id);
                      }}
                      sx={{ padding: 0, marginLeft: 1 }} // Adjust spacing for the icon
                    >
                      <CloseIcon
                        sx={{
                          color: "#000000",
                          fontWeight: 600,
                        }}
                      />
                    </IconButton>
                  </div>
                }
              />
            ))}
          </CustomTabsList>
        </Box>
        <div className="mapping-tab-line" />
        <TabPanel value="list">
          <ListGroups groupsList={groupsList} setGroupsList={setGroupsList} />
        </TabPanel>
        <TabPanel value="create">
          <CreateGroup />
        </TabPanel>
        {groupsList.detail.map((ds) => (
          <TabPanel value={ds.id.toString()}>
            <EditGroup id={ds.id} />
          </TabPanel>
        ))}
      </TabContext>
    );
  else if (component === "vyuGPT")
    return (
      <TabContext value="chat">
        <Box className="tab-list-box-common">
          <div className="company-info">
            <img
              src={parsedCompanyInfo.companyLogo}
              alt="Proeffective Logo"
              className="company-logo"
            />
            {parsedCompanyInfo.show === true && (
              <span className="vyu-text">{parsedCompanyInfo.companyName}</span>
            )}
          </div>
          <CustomTabsList
            sx={{
              background: "#f8f8f8",
              border: "1px solid #eaecf0",
              borderRadius: "8px",
            }}
          >
            <CustomTab
              value="chat"
              label={
                <Tooltips title="vYu GPT" placement="right">
                  <span className="tab-header">vYu GPT</span>
                </Tooltips>
              }
            />
          </CustomTabsList>
        </Box>
        <div className="mapping-tab-line" />
        <TabPanel value="chat">
          <VyuGPT />
        </TabPanel>
      </TabContext>
    );
  else if (component === "reportGrid")
    return (
      <TabContext value="chat">
        <Box className="tab-list-box-common">
          <CustomTabsList
            sx={{
              background: "#f8f8f8",
              border: "1px solid #eaecf0",
              borderRadius: "8px",
            }}
          >
            <CustomTab
              value="chat"
              label={
                <Tooltips title="Report" placement="right">
                  <span className="tab-header">Report</span>
                </Tooltips>
              }
            />
          </CustomTabsList>
        </Box>
        <div className="mapping-tab-line" />
        <TabPanel value="chat">
          <ReportGrid />
        </TabPanel>
      </TabContext>
    );
  else return <Box>No Data</Box>;
}
